import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import { lazy } from "react";
import PrivateRoutes from "./private-wrarpper";
import { paths } from "./paths";
import RootBoundary from "@/components/partials/error-boundry";
import PublicRoutes from "./public-wrapper";
const HomePage = lazy(() => import("@/pages/home"));

//Modules
const ModuleListPage = lazy(() => import("@/pages/modules"));
const ModuleViewPage = lazy(() => import("@/pages/modules/view"));
const ModuleAddPage = lazy(() => import("@/pages/modules/add"));

//Statics
const StaticsListPage = lazy(() => import("@/pages/statics/list"));
const StaticsViewPage = lazy(() => import("@/pages/statics/view"));
const StaticsAddPage = lazy(() => import("@/pages/statics/add"));

//Discounts
const DiscountsListPage = lazy(() => import("@/pages/discounts/list"));
const DiscountsViewPage = lazy(() => import("@/pages/discounts/view"));
const DiscountsAddPage = lazy(() => import("@/pages/discounts/add"));

//Users
const UsersListPage = lazy(() => import("@/pages/users/list"));
const UsersViewPage = lazy(() => import("@/pages/users/view"));
const UsersAddPage = lazy(() => import("@/pages/users/add"));

//Login
const LoginPage = lazy(() => import("@/pages/login"));

//Roles
const RolesListPage = lazy(() => import("@/pages/roles/list"));
const RolesViewPage = lazy(() => import("@/pages/roles/view"));
const RolesAddPage = lazy(() => import("@/pages/roles/add"));

//Primary Fields
const PrimaryFieldsListPage = lazy(() => import("@/pages/primary-fields/list"));

//Media
const MediaListPage = lazy(() => import("@/pages/media/list"));

const router = createBrowserRouter([
  {
    element: <PrivateRoutes />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: paths.home,
        element: <Navigate to={paths.dashboard.index} />,
      },
      {
        path: paths.dashboard.index,
        element: <HomePage />,
      },
      {
        path: paths.modules.index,
        children: [
          {
            index: true,
            element: <ModuleListPage />,
          },
          {
            path: paths.modules.view,
            element: <ModuleViewPage />,
          },
          {
            path: paths.modules.add,
            element: <ModuleAddPage />,
          },
        ],
      },
      {
        path: paths.statics.index,
        children: [
          {
            index: true,
            element: <StaticsListPage />,
          },
          {
            path: paths.statics.view,
            element: <StaticsViewPage />,
          },
          {
            path: paths.statics.add,
            element: <StaticsAddPage />,
          },
        ],
      },
      {
        path: paths.discounts.index,
        children: [
          {
            index: true,
            element: <DiscountsListPage />,
          },
          {
            path: paths.discounts.view,
            element: <DiscountsViewPage />,
          },
          {
            path: paths.discounts.add,
            element: <DiscountsAddPage />,
          },
        ],
      },
      {
        path: paths.users.index,
        children: [
          {
            index: true,
            element: <UsersListPage />,
          },
          {
            path: paths.statics.view,
            element: <UsersViewPage />,
          },
          {
            path: paths.statics.add,
            element: <UsersAddPage />,
          },
        ],
      },
      {
        path: paths.roles.index,
        children: [
          {
            index: true,
            element: <RolesListPage />,
          },
          {
            path: paths.roles.view,
            element: <RolesViewPage />,
          },
          {
            path: paths.roles.add,
            element: <RolesAddPage />,
          },
        ],
      },
      {
        path: paths.primaryFields.index,
        children: [
          {
            index: true,
            element: <PrimaryFieldsListPage />,
          },
        ],
      },
      {
        path: paths.media.index,
        element: <MediaListPage />,
      },
    ],
  },
  {
    element: <PublicRoutes />,
    children: [
      {
        path: paths.login.index,
        element: <LoginPage />,
      },
    ],
  },
  {
    path: "*",
    element: <>Not Found</>,
  },
]);

export default router;
